import { keepPreviousData, useQuery } from "@tanstack/react-query";
import axiosInstance from "axiosConfig";
import { OptionsType } from "types/UtilsTypes";

export default function useGetCountriesCurrency() {
  return useQuery({
    queryKey: ["countries/currency"],

    queryFn: async () => {
      return axiosInstance.get(`countries/currency`).then((res) => res.data);
    },
    placeholderData: keepPreviousData,
    select: (data: OptionsType[]) => data,
    staleTime: 1000 * 60 * 60 * 24,
  });
}
